module.exports = __webpack_public_path__ + "350af45f4827e28cb8a669137bf34942.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-main-420.jpg
// module id = 457
// module chunks = 0